import React from 'react';
import { Provider, connect } from 'react-redux';
import { Route, Switch, BrowserRouter, HashRouter, Redirect } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider, withI18n } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/ru';

import i18n from './i18n';
import { Loader } from '~components/loader';
import Landing from '~routes/login-page';
import BlockedPage from '~routes/blocked-page';
import Main from '~routes/main';
import LawsItemPageTokenLazy from '~routes/laws-item-page-token/lazy';
import DigestsItemPageTokneLazy from '~routes/digests-item-page-token/lazy';
import CalendarPageLazy from '~routes/main/calendar-page/lazy';
import { store, persistor } from '~redux_related/store';
import { ToastContainer } from 'react-toastify';
import Cleaner from './cleaner';
import DeviceUpdater from './deviceUpdater';
import { identifyUserAnalytics } from '~utils/analytics';
import { checkUserExpirationDateExpired } from '~utils/helpers';

import 'react-toastify/dist/ReactToastify.css';

import './App.scss';

class ErrorBoundary extends React.Component {
    state = { error: '' };

    static getDerivedStateFromError(error) {
        return { error: error };
    }

    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo);
    }

    render() {
        const { error } = this.state;

        return error ? (
            <div className="error-page">
                <h2 className="error-page__message">
                    Error: {error.code} {error.message}
                </h2>
                {error.stack && <h3 className="error-page__message">Error stack:</h3>}
                {error.stack &&
                    error.stack.split(' at ').map((item, i) => {
                        if (i > 0)
                            return (
                                <p className="error-page__stack" key={i + 'err'}>
                                    at {item}
                                </p>
                            );
                        return null;
                    })}
            </div>
        ) : (
            this.props.children
        );
    }
}

const Router = window.history.pushState ? BrowserRouter : HashRouter;

moment.updateLocale('ru', {
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сент', 'Окт', 'Ноя', 'Дек'],
});

function AppComponent({ isNewsUserLogged, isLawsUserLogged, isBlockedUser, user }) {
    React.useEffect(() => {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        if (user && (user.newsUser.id || user.lawsUser.id)) {
            identifyUserAnalytics(user);
        } else {
            identifyUserAnalytics();
        }
    }, [user]);

    const isUserLogged = isNewsUserLogged || isLawsUserLogged;

    return (
        <React.Fragment>
            <Cleaner />
            <Router>
                <Switch>
                    <Route path="/calendar" component={CalendarPageWrapper} />
                    {isBlockedUser && <Route path="/" component={BlockedPage} />}
                    {!isUserLogged && <Route path="/laws/:id/:token" component={LawsItemPageTokenLazy} />}
                    {!isUserLogged && <Route path="/digests/:id/:token" component={DigestsItemPageTokneLazy} />}
                    <Route path="/" component={isUserLogged ? Main : Landing} />
                    <Redirect to="/" />
                </Switch>
            </Router>
            <DeviceUpdater />
            <ToastContainer closeButton={false} draggable={false} hideProgressBar />
        </React.Fragment>
    );
}

const CalendarPageWrapper = (props) => {
    const params = new URLSearchParams(props.location.search);
    const lawId = params.get('law_id');
    const ut = params.get('ut');

    console.log('+++law id + ut', lawId, ut);

    return <CalendarPageLazy lawId={lawId} ut={ut} />;
};

const mapStateToProps = (state) => ({
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isBlockedUser: state.user.blocked,
    user: state.user,
});

const App = connect(mapStateToProps)(withI18n()(AppComponent));

function AppWithPersistor() {
    return (
        <ErrorBoundary>
            <I18nextProvider i18n={i18n}>
                <Provider store={store}>
                    <PersistGate persistor={persistor} loading={<Loader />}>
                        <App />
                    </PersistGate>
                </Provider>
            </I18nextProvider>
        </ErrorBoundary>
    );
}

export default AppWithPersistor;



// WEBPACK FOOTER //
// ./src/App.js